// extracted by mini-css-extract-plugin
export default {"divider":"views-ProductPage-themes-BGH-divider__divider--s91AI"};